import http from '../../services/http-common';

class ProductService {

  getForList(data) {
    let queryParams = new URLSearchParams(data).toString();
    return http.get(`/Product/list`);
  }

  getItemDescCode(CompanyID) {
    let queryParams = new URLSearchParams({CompanyID:CompanyID}).toString();
    return http.get(`/digitalInvoicing/pdi/v1/itemdesccode?${queryParams}`);
  }
  getUOMDDSource(data) {
    let queryParams = new URLSearchParams(data).toString();
    return http.get(`/digitalInvoicing/pdi/v2/HS_UOM?${queryParams}`);
  }
  
  


  addRecords(data) {
    return http.post(`/Product/add`, data);
  }

  updateMainData(data) {
    return http.put(`/Product/update`, data);
  }

}

export default new ProductService();